import React from 'react'
import FormSection from '../../Common/form/formSection/FormSection'
import Category from '../fields/Category'
import Profession from '../fields/Profession'
import Qualification from '../fields/Qualification'
import Speciality from '../fields/Speciality'

type ProfessionalSectionProps = {
    children?: React.ReactNode
}

const ProfessionalSection = ({ children }: ProfessionalSectionProps) => (
    <FormSection label="Activité professionnelle">
        <Qualification />
        <Profession />
        <Speciality />
        {children}
        <Category />
    </FormSection>
)

export default ProfessionalSection
